import { render, staticRenderFns } from "./PartnerCampaignListView.vue?vue&type=template&id=89853884&scoped=true"
import script from "./PartnerCampaignListView.vue?vue&type=script&lang=js"
export * from "./PartnerCampaignListView.vue?vue&type=script&lang=js"
import style0 from "./PartnerCampaignListView.vue?vue&type=style&index=0&id=89853884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89853884",
  null
  
)

export default component.exports